module.exports = __webpack_public_path__ + "img/grundung-1.853b4b28.jpg";